import Component from '@glimmer/component';

import { action } from '@ember/object';
import didUpdate from '@ember/render-modifiers/modifiers/did-update';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import DynamicNode from 'rise-ui/components/dynamic-node.gjs';
import and from 'rise-ui/helpers/and.js';
import hasBlocks from 'rise-ui/helpers/has-blocks.js';
import isSet from 'rise-ui/helpers/is-set.js';
import or from 'rise-ui/helpers/or.js';
import { softSetProperties } from 'rise-ui/utils/object.js';

export default class UiPageBodyComponent extends Component {
  @service uiPages;
  @tracked page;

  constructor() {
    super(...arguments);
    const { location, page } = this.args;
    this.onPage(null, [ location, page ]);
  }

  @action onPage(el, [ location, page ]) {
    if (softSetProperties(this, { _location: location, _page: page }, true)) {
      this.__page = page || location && this.uiPages.get(location);
    }
    this.page = this.__page;
  }

  @tracked hasBlock;
  @tracked hasNamedBlock;

  @action onHasBlock(hasNamedBlock) {
    const { noBlock = {} } = this.args;
    this.hasBlock = false;
    this.hasNamedBlock = {};
    Object.entries(hasNamedBlock).forEach(([ block, hasBlock ]) => {
      if (!noBlock[block] && hasBlock) {
        this.hasNamedBlock[block] = true;
        this.hasBlock = true;
      }
    });
  }

  <template>
    {{#let
      (hasBlocks "error" (has-block "error") "default" (has-block "default") noBlock=@noBlock)
      (isSet this.page)
      as | hasBlocks hasPage |
    }}
    <div {{didUpdate this.onPage @location @page}}>
    {{#if (or hasPage hasBlocks.isNotEmpty)~}}
      {{#if (and hasBlocks.error (or @hasError this.page.isRejected))}}
        <div class="c-ui-page-body__error qa-ui-page-error">
          {{yield to="error"}}
        </div>
      {{else if (or hasPage hasBlocks.default)}}
        <div class="qa-ui-page-body c-html-content">
          {{~#if this.page.isPending~}}
            {{yield}}
          {{~else~}}
            <DynamicNode @node={{this.page.value.bodyProcessed}} @data={{@data}} />
          {{~/if~}}
        </div>
      {{/if}}
    {{~/if~}}
    </div>
    {{/let}}
  </template>
}
